import { queryOptions } from '@tanstack/react-query'

import { CheckoutAvailabilityService } from '@inter-ikea-kompis/services'
import type { IDexfSettings, IProductItem } from '@inter-ikea-kompis/types'

import { KOMPIS_SERVICE_BASE_SETTINGS } from '@/integrations/kompis/constants'

export function storeAvailabilitiesQueryOptions(
  dexfSettings: IDexfSettings,
  productItems: IProductItem[],
  storeId: string | null,
) {
  return queryOptions({
    enabled: !!storeId,
    queryFn: async () => await fetchStoreAvailabilities(dexfSettings, productItems, storeId),
    queryKey: ['store-availabilities', storeId, productItems.toSorted().map((item) => item.id)],
  })
}

async function fetchStoreAvailabilities(
  dexfSettings: IDexfSettings,
  productItems: IProductItem[],
  storeId: string | null,
) {
  if (!storeId) return []
  const checkoutAvailabilityService = new CheckoutAvailabilityService({
    ...KOMPIS_SERVICE_BASE_SETTINGS,
    settings: dexfSettings,
  })

  return await checkoutAvailabilityService.getStoreAvailabilities(storeId, productItems)
}
